import BaseService from '@root/core/class/BaseService';

class buskService extends BaseService {
  public getListWarehouse = (
    page: number,
    fromDt?: string,
    toDt?: string,
    state?: string,
    filter?: string,
    input?: string,
    sort?: boolean
  ) => {
    const inputEncode = input?.replaceAll('%', '%25').replaceAll('#', '%23');
    return this.get(
      `/warehouses?page=${page}&limit=10${
        Boolean(state) ? '&filterBy=state:' + state : '&filterBy='
      }${Boolean(input) ? '&search=' + inputEncode : '&search='}${
        Boolean(fromDt) ? '&fromDt=' + fromDt : '&fromDt='
      }${Boolean(toDt) ? '&toDt=' + toDt : '&toDt='}${
        Boolean(filter) ? '&searchBy=' + filter : '&searchBy='
      }${Boolean(!sort) ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC'}`
    );
  };

  public exportWarehouseExcell = (
    page: number,
    fromDt?: string,
    toDt?: string,
    state?: string,
    filter?: string,
    input?: string,
    sort?: boolean
  ) => {
    const inputEncode = input?.replaceAll('%', '%25').replaceAll('#', '%23');

    return this.post(
      `/warehouses/export?page=${page}&${
        Boolean(state) ? '&filterBy=state:' + state : '&filterBy='
      }${Boolean(input) ? '&search=' + inputEncode : '&search='}${
        Boolean(fromDt) ? '&fromDt=' + fromDt : '&fromDt='
      }${Boolean(toDt) ? '&toDt=' + toDt : '&toDt='}${
        Boolean(filter) ? '&searchBy=' + filter : '&searchBy='
      }${
        Boolean(!sort) ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC'
      }`,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  public exportWarehouseExcellById = (listId: any) => {
    return this.post(
      `/warehouses/export`,
      {
        ids: listId
      },
      {
        responseType: 'blob'
      }
    );
  };
}

export default new buskService('/api/v1/admin', true);
